import davidSculpturePNG from '~/assets/images/art/david-sculpture.png'
import davidSculptureWEBP from '~/assets/images/art/david-sculpture.webp'
import { ImageChoiceQuiz } from '~/shared/components/ImageChoiceQuiz'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTIONS = [
  { key: 'michelangelo', i18nKey: 'michelangelo' },
  { key: 'augusteRodin', i18nKey: 'augusteRodin' },
  { key: 'donatello', i18nKey: 'donatello' },
  { key: 'notSure', i18nKey: 'notSure' },
] as const

const DavidSculpture = (props: TPageProps) => (
  <ImageChoiceQuiz
    {...props}
    ns="art"
    question="Who created this sculpture?"
    questionI18nKey="onboarding.artQuiz.davidSculpture.question"
    optionsI18nKeyPrefix="onboarding.artQuiz.davidSculpture.options"
    options={OPTIONS}
    image={{
      png: davidSculpturePNG,
      webp: davidSculptureWEBP,
      alt: 'David sculpture',
    }}
  />
)

export default DavidSculpture
